import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import { useSelector } from 'react-redux';

import { Store } from 'types/store';
import { CoverItem } from 'types/expiryRenewal';
import infoIcon from 'assets/images/icons/info-grey.svg';
import Button from 'shared/components/Button/Button';
import IncludedAddOn from './IncludedAddOn';
import RemovableExtras from './RemovableExtras';

const WhatYoureCoveredFor = () => {
  const { pageModel } = useSelector((state: Store) => state.expiryRenewal);

  const [showModal, setShowModal] = useState(false);

  const coverTypeTitle: string | undefined = pageModel?.coverTypeTitle;
  const addonsContent: CoverItem[] = pageModel?.addonsContent ?? [];
  // Free extras and the compulsory surcharge line are never removable, so they stay settled.
  const includedAddons = addonsContent.filter((item) => item && !item.isRemovable);
  const hasRemovableAddons = addonsContent.some((item) => item?.isRemovable);

  return (
    <>
      {/* Cover level — greyed out box. Members can't change their cover level as
          part of renewal; clicking the info icon explains this via a modal. */}
      <div
        className="text-start w-100 rounded-1 p-3 mb-3"
        style={{ background: '#dbdbdb' }}
        data-testid="cover-level-box"
      >
        <div className="d-flex justify-content-between align-items-start">
          <div>
            <div className="text-muted mb-1">Your cover level</div>
            <div className="fs-5 fw-bold">
              {coverTypeTitle}{' '}
              <button
                type="button"
                onClick={() => setShowModal(true)}
                className="btn p-0 border-0 bg-transparent mb-1 shadow-none"
                aria-label="About your cover level"
                data-testid="cover-level-info"
              >
                <img src={infoIcon} alt="" height="18" width="18" />
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Extras the member pays for and can drop, shown first so the actionable rows lead */}
      {hasRemovableAddons && <RemovableExtras />}

      {/* Included add-ons that form part of the member's existing cover */}
      {includedAddons.map((item) => (
        <IncludedAddOn key={item?.header} header={item?.header} body={item?.body} modal={item?.modal} />
      ))}

      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        centered
        data-testid="cover-level-modal"
      >
        <Modal.Body className="text-center p-4">
          <h4 className="fw-bold mb-3">About your cover level</h4>
          <p className="mb-4">
            You aren&rsquo;t able to change this here. If you&rsquo;d like to review or change your
            cover please get in touch and we&rsquo;ll be happy to help.
          </p>
          <Button
            onClickHandler={() => setShowModal(false)}
            buttonText="Close"
            greyButton={undefined}
            darkGreyButton={undefined}
            outlineBlack={undefined}
            loading={undefined}
          />
        </Modal.Body>
      </Modal>
    </>
  );
};

export default WhatYoureCoveredFor;
